export default __webpack_public_path__ + "static/media/GDPR.1787353e.png";